import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Card, Button } from "components/ui_new/index";
import { formatDate } from "utils/misc";
import { deletePatientDocument } from "actions/documents";
import ClockIcon from "assets/images/clock_gray.png";
import useTranslate from "hooks/use-translate-language";
import moment from "moment-timezone";

const DocumentItem = ({
  document_id,
  updated_date,
  title,
  description,
  // upload_date,
  file,
  onKeyDown
}) => {
  const translate = useTranslate();
  const dispatch = useDispatch();

  const getTimezone = () => {
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return `(${moment.tz(browserTimezone).format("z")})`;
  };

  const getDocumentAriaLabel = (action, itemName) => {
    const date = formatDate(updated_date, "DD, MMMM YYYY");
    const time = formatDate(updated_date, "h:mm A");
    const timezone = getTimezone();
    return `${action} ${itemName} ${date} ${time} ${timezone}`;
  };

  const handleButtonKeyDown = e => {
    onKeyDown?.(e);

    if (
      (e.key === "Enter" || e.key === " ") &&
      e.currentTarget.classList.contains("view-button")
    ) {
      e.preventDefault();
      window.open(file);
    }
  };

  const actionsContainer = (
    <div className="document-actions">
      <Button
        variant="contained"
        onClick={event => {
          event.preventDefault();
          window.open(file);
        }}
        onKeyDown={handleButtonKeyDown}
        className="view-button"
        aria-label={getDocumentAriaLabel(translate("view"), title)}
        tabIndex={0}
      >
        {translate("view")}
      </Button>
      <Button
        variant="outlined"
        onClick={async () => {
          await dispatch(deletePatientDocument(document_id));
        }}
        onKeyDown={handleButtonKeyDown}
        className="delete-button"
        aria-label={getDocumentAriaLabel(translate("delete"), title)}
        tabIndex={0}
      >
        {translate("delete")}
      </Button>
    </div>
  );

  return (
    <Card key={document_id} actionsContainer={actionsContainer}>
      <div className="document-container">
        <div className="document-content">
          <div className="document-header">
            <div className="document-time-container">
              <div className="time-icon">
                <img src={ClockIcon} alt="" />
              </div>
              <div className="time-content">
                <span className="date-bold">
                  {formatDate(updated_date, "DD, MMMM YYYY")}
                </span>
                <div className="time-line">
                  {formatDate(updated_date, "h:mm A")}
                </div>
                <div className="timezone-line">{getTimezone()}</div>
              </div>
            </div>
          </div>
          <div className="document-description">
            <span
              className="document-description-title"
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                }
                onKeyDown?.(e);
              }}
              role="button"
              tabIndex={-1}
              aria-label={getDocumentAriaLabel(translate("view"), title)}
            >
              {title}
            </span>
            <span
              className="document-description-description"
              onClick={() => window.open(file)}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  window.open(file);
                }
                onKeyDown?.(e);
              }}
              role="button"
              tabIndex={-1}
              aria-label={getDocumentAriaLabel(translate("view"), description)}
            >
              {description}
            </span>
          </div>
        </div>
      </div>
    </Card>
  );
};

DocumentItem.propTypes = {
  document_id: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  upload_date: PropTypes.string,
  updated_date: PropTypes.string,
  file: PropTypes.string,
  onKeyDown: PropTypes.func
};

export default DocumentItem;
